import { useCallback, useEffect, useState } from 'react';

import { getSendAsAddresses } from 'lib/api/getSendAsAddresses';
import { Maybe } from 'types/UtilityTypes';

export type UseSendAsAddressesResult = {
  addresses: string[];
  loading: boolean;
  error: Maybe<Error>;
  refetch: () => void;
};

export default function useSendAsAddresses(): UseSendAsAddressesResult {
  const [addresses, setAddresses] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Maybe<Error>>(null);

  const fetchAddresses = useCallback(async () => {
    setLoading(true);
    setError(null);
    const result = await getSendAsAddresses();
    result
      .map((data) => {
        setAddresses(data.addresses ?? []);
      })
      .mapErr((e) => {
        setError(
          new Error(
            typeof e.message === 'string'
              ? e.message
              : 'Failed to load send-as addresses'
          )
        );
        setAddresses([]);
      });
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchAddresses();
  }, [fetchAddresses]);

  return { addresses, loading, error, refetch: fetchAddresses };
}
